<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class=" mt-4">
        <Activation />
        <p class="font18bold breadcrums">
            <router-link to="/">Home</router-link> |
            <router-link to="/languages/interpreters">Interpreters</router-link> |
            <router-link to="#">Join </router-link>
        </p>

        <div class="_container mt-5 bg-black">
            <div class="row  row-h">
                <b-col v-if="interpreter.photo" cols="6" md="4" class="img-bg" v-bind:style='{ backgroundImage: "url(" + interpreter.photo + ")", }'>
                </b-col>
                <b-col cols="5" md="4" class="desktop mt-4 text-white">
                    <div class="font18 mb-2">
                        <b-icon class="mr-2" style="color:#F7B131" shift-v="1" font-scale="0.7" icon="clipboard"></b-icon> {{interpreter.title || ''}}
                    </div>
                    <p class="font14 text-capitalize" v-if="interpreter.hire_status == 1">
                        <b-icon class="mr-2" style="color:#F7B131" shift-v="1" font-scale="1" icon="clock-history"></b-icon> {{interpreter.hire_status ==1 ? 'For hire': 'Not for hire'}}
                    </p>
                    <p class="font14">
                        <b-icon class="mr-2" style="color:#F7B131" shift-v="-2" font-scale="1" icon="tag"></b-icon>from {{interpreter.from_language }} to {{interpreter.to_language}}
                    </p>
                    <p class="font14">
                        <b-icon class="mr-2" style="color:#F7B131" shift-v="1" font-scale="1" icon="clipboard"></b-icon> {{interpreter.from_language}} - {{interpreter.from_lang_experience}} years
                    </p>
                    <p class="font14">
                        <b-icon class="mr-2" style="color:#F7B131" shift-v="1" font-scale="1" icon="clipboard"></b-icon> {{interpreter.to_language}} - {{interpreter.to_lang_experience}} years
                    </p>

                </b-col>
                <b-col cols="6" md="4" class="mt-4 text-white">
                    <button @click="openHireModal(interpreter)" class="mt-2 btn btn-warning">Hire Now
                        <b-icon scale="0.9" icon="arrow-right"></b-icon>
                    </button>

                    <div class="mt-3">
                        <span class="font12">Share to social media</span> <br>
                        <facebook class="mr-2" :title="interpreter.business_name" :url="url" scale="2" />
                        <twitter class="mr-2" :url="url" scale="2" />
                        <whats-app :url="url" scale="2" />
                    </div>
                </b-col>

            </div>

        </div>
        <b-row class="inst-details mt-n2 bg-white text-center">
            <b-col cols="12" md="4" @click="showHost" :class="isHost == true ? 'active':''" class="inner-header-box">
                <div>
                    <b-icon shift-v="-1" icon="person"></b-icon> About Interpreter
                </div>
            </b-col>
            <b-col cols="12" md="4" @click="showReviews" :class="isReviews == true ? 'active':''" class="inner-header-box">
                <div>
                    <b-icon shift-v="-2" icon="chat-left-dots"></b-icon> Reviews
                </div>
            </b-col>
            <b-col cols="12" md="4" @click="showDetails" :class="isDetails == true ? 'active':''" class="inner-header-box">
                <div>
                    <b-icon shift-v="2" icon="clipboard"></b-icon> Service Description
                </div>
            </b-col>

        </b-row>
        <div v-if="isHost" class="card-no-shadow row p-2 p-3-md mr-4 ml-4 mt-4 profile-contain ">
            <b-col cols="12" md="8">
                <div class="row p-3-md">
                    <b-col cols="4" v-if="interpreter.host.gender">
                        <p class="font14">Gender</p>
                        <p class="font16 text-capitalize">
                            <b-icon font-scale="0.9" icon="person"></b-icon> {{interpreter.host.gender}}
                        </p>
                    </b-col>
                    <b-col cols="4">
                    </b-col>
                    <b-col cols="4" v-if="interpreter.host.nationality">
                        <p class="font14">Nationality</p>
                        <p class="font16">
                            <b-icon font-scale="0.9" icon="globe"></b-icon> {{interpreter.host.nationality.name}}
                        </p>
                    </b-col>
                </div>
                <div class="row p-3-md">
                    <b-col cols="8" v-if="interpreter.host.state_residence">
                        <p class="font14">State</p>
                        <p class="font16">
                            <b-icon font-scale="0.9" icon="globe"></b-icon> {{interpreter.host.state_residence}}
                        </p>
                    </b-col>
                    <b-col cols="4" v-if="interpreter.host.country_residence">
                        <p class="font14">Country Residence</p>
                        <p class="font16">
                            <b-icon font-scale="0.9" icon="globe"></b-icon> {{interpreter.host.country_residence}}
                        </p>
                    </b-col>

                </div>
                <div class="row p-3-md">
                    <b-col cols="8" v-if="interpreter.host.interests">
                        <p class="font14">Occupation</p>
                        <p class="font16">
                            <b-icon font-scale="0.9" icon="bag"></b-icon> {{interpreter.host.interests}}
                        </p>
                    </b-col>
                    <b-col cols="4">
                        <p class="font14">Joined</p>
                        <p class="font16">
                            <b-icon font-scale="0.9" icon="clock"></b-icon> {{interpreter.created_at | moment("MM/DD/YYYY")}}
                        </p>
                    </b-col>

                </div>
            </b-col>
            <b-col cols="12" md="4" class="profile-contain">
                <div class="text-center">
                    <img :src="interpreter.host.photo_full ? interpreter.host.photo_full : this.defaultImage" style="" class="p-3" alt="">
                    <div class="mt-3">{{interpreter.host.first_name}} </div>
                    <b-form-rating readonly show-value inline size="sm" v-model="interpreter.host.rating"></b-form-rating>
                    <p class="font14">
                        {{interpreter.host.bio}}
                    </p>

                </div>
            </b-col>
        </div>
        <div v-if="isReviews" class="card-no-shadow p-3 mr-4 ml-4 mt-4">
            <div class="row justify-content-between">
                <p class="font14" style="color:#565C63">
                    Reviews
                </p>
            </div>
            <b-tabs card>
                <b-tab title="Reviews" active>
                    <b-card-text v-if="interpreter.reviews.length > 0">
                        <div class="row" v-for="(rate, index) in interpreter.reviews " :key="index">
                            <b-col cols="1">
                                <img class="rating-profile" :src="rate.rater.photo_thumb" alt="">
                            </b-col>
                            <b-col cols="10">
                                <div class="font12 pl-2">{{rate.rater.first_name}}</div>
                                <b-form-rating readonly show-value inline size="sm" v-model="rate.rating">
                                </b-form-rating>
                                <p class="font12 pl-2">
                                    {{rate.comment}} </p>
                            </b-col>
                        </div>

                    </b-card-text>
                    <p v-else>
                        No reviews yet
                    </p>
                </b-tab>
                <b-tab title="Rate Interpreter">
                    <b-card-text>
                        <div class="text-center">
                            <p class="rating-title">{{interpreter.average_ratings}}</p>
                            <p>Total Avg. Ratings</p>
                            <b-form-rating class="star-icon mb-3" show-value size="lg" v-model="rating">
                            </b-form-rating>
                            <b-form-group class="mb-3" label-for="comment">
                                <textarea style="height:auto !important" required rows="5" v-model="comment" placeholder="Comment" class="shadow custom-control form-control"></textarea>
                            </b-form-group>
                            <button @click="rateInterpreter(interpreter)" class="btn btn-warning btn-below">
                                <b-icon font-scale="0.99" icon="heart"></b-icon> {{btnRating}}
                            </button>
                        </div>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </div>
        <b-row v-if="isDetails" class="card-no-shadow p-3 mr-4 ml-4 mt-4">
            <b-col cols="12" md="4">
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold">Interpreting from : </span> {{interpreter.from_language}}
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold">Interpreting to : </span> {{interpreter.to_language}}
                </p>
                <p class="font14 text-capitalize" style="color:#565C63">
                    <span class="font-weight-bold"> Area of Specialization </span>: {{interpreter.specializations[0].title}}
                </p>
            </b-col>
            <b-col cols="12" md="4">
                <p class="font14 text-capitalize" style="color:#565C63">
                    <span class="font-weight-bold"> Client Choice:</span> {{interpreter.client_choice}}
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Translation: </span> {{interpreter.translation_type === 'yes' ? 'translate official document':'cannot translate official documents'}}
                </p>

            </b-col>
            <b-col cols="12" md="4">
                <p class="font14 text-capitalize" style="color:#565C63">
                    <span class="font-weight-bold"> Mode: </span> {{interpreter.mode}}
                </p>
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Certification: </span> {{interpreter.certification === 'yes' ? 'Certified':'Not Certified'}}
                </p>

            </b-col>
            <b-col cols="12">
                <p class="font14" style="color:#565C63">
                    <span class="font-weight-bold"> Description </span>:
                    <span v-html="interpreter.reason"></span>
                </p>
            </b-col>

        </b-row>

    </b-container>

    <b-modal id="rate-host" centered title="Rate Host" hide-footer>
        <div class="text-center">
            <p class="rating-title">{{interpreter.rating}}</p>
            <p>Total Avg. Ratings</p>
            <b-form-rating class="star-icon mb-3" show-value size="lg" v-model="interpreter.host.rating"></b-form-rating>
            <button @click="rateHost(interpreter)" class="btn btn-warning btn-below">
                <b-icon font-scale="0.99" icon="heart"></b-icon> Rate Now
            </button>
        </div>

    </b-modal>
    <b-modal size="lg" id="availability" centered title="Select Availability" hide-footer>
        <form @submit.prevent="proposeDateTime">
            <b-form-group class="mb-4" label-for="">
                <label for="">Select date and time</label>
                <date-range-picker required ref="picker" :date-format="dateFormat" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }" :timePicker="true" :showDropdowns="true" v-model="dateRange">
                    <template v-slot:input="picker" style="min-width: 350px;">
                        {{ picker.startDate }} - {{ picker.endDate }}
                    </template>
                </date-range-picker>
            </b-form-group>
            <b-form-group class="" label-for="input-1">
                <b-form-checkbox v-model="isVirtual" switch inline class="col-md-12">
                    check this if the address is virtual
                </b-form-checkbox>
            </b-form-group>
            <b-form-group class="mb-4" label-for="address" v-if="!isVirtual">
                <b-input-group class="">
                    <b-input-group-prepend is-text>
                        <b-icon icon="bookmark"></b-icon>
                    </b-input-group-prepend>
                    <vue-google-autocomplete id="l-map" required ref="address" classname="form-control" placeholder="Enter a physical address or location" v-on:placechanged="getAddressData" v-model="guest_address">
                    </vue-google-autocomplete>
                </b-input-group>
            </b-form-group>
            <b-form-group class="mb-4" label-for="address" v-if="isVirtual">
                <b-input-group class="">
                    <b-input-group-prepend is-text>
                        <b-icon icon="link45deg"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input class="" type="text" required v-model="guest_address" placeholder="Enter virtual link"></b-form-input>
                </b-input-group>
            </b-form-group>

            <b-form-group class="mb-2" label-for="event">
                <button class="btn btn-warning btn-below font12">{{modalbtnText}}</button>
            </b-form-group>
        </form>
    </b-modal>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {
    Facebook,
    Twitter,
    WhatsApp
} from "vue-socialmedia-share";

import axios from "axios";
import {
    getBaseUrl
} from "../../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'interpreter-details',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        VueGoogleAutocomplete,
        DateRangePicker,
        Facebook,
        WhatsApp,
        Twitter,
        Activation,
        Footer
    },
    metaInfo() {
        return {
            title: this.interpreter.club_name,
            meta: [{
                    name: 'description',
                    content: this.interpreter.reason
                },
                {
                    property: "og:title",
                    content: this.interpreter.title
                },
                {
                    property: "og:image",
                    content: this.interpreter.images
                },
                {
                    property: 'og:site_name',
                    content: 'Culture Square'
                },
                {
                    property: 'og:type',
                    content: 'website'
                },
                {
                    name: 'robots',
                    content: 'index,follow'
                }
            ]
        }
    },
    data: function () {
        return {
            headerText: "Language Interpreters",
            subText: "Connect with people round the globe by joining a language interpreter",
            fadedText: "Language",
            isVirtual: false,
            btnRating: 'Rate Now',
            searchInput: {
                name: '',
                flag: ''
            },
            defaultImage: require('../../../assets/images/prof-img.png'),
            isReviews: false,
            isHost: false,
            isDetails: true,
            languages: [],
            countryAdded: [],
            interpreter: {
                host: {},
                specializations: [{
                    title: ''
                }]
            },
            message: '',
            booking: {},
            sendbtnText: 'Join',
            url: '',
            dateRange: {
                startDate: new Date().toISOString(),
                endDate: new Date().toISOString()
            },
            modalbtnText: "Propose Time",
            guest_address: "",
            comment: '',
            rating: 0
        }
    },
    mounted() {
        this.geInterpreterDetails();
    },
    computed: {
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn;
        },
        currentUser: function () {
            return this.$store.getters.currentUser;
        },
    },
    methods: {
        getAddressData: function (_addressData, placeResultData) {
            if (placeResultData.formatted_address !== null) {
                this.guest_address = placeResultData.formatted_address;
            }
        },
        dateFormat(classes, date) {
            if (!classes.disabled) {
                classes.disabled = date.getTime() < new Date()
            }
            return classes
        },
        openHireModal(interpreter) {
            if (!this.isLoggedIn) {
                this.$router.push({
                    name: "sign-in",
                    query: {
                        redirect: `/languages/interpreter/${this.$route.params.id}/details`,
                    },
                });
            } else {
                if (interpreter.host.user_id === this.currentUser.user_id) {
                    this.$root.$refs.A.makeToast('danger', 'You can not hire yourself')
                } else {
                    this.interpreter = interpreter
                    this.$bvModal.show('availability')
                }
            }
        },
        showHost() {
            this.isHost = true;
            this.isReviews = false;
            this.isDetails = false;
        },
        showReviews() {
            this.isHost = false;
            this.isReviews = true;
            this.isDetails = false;
        },
        showDetails() {
            this.isHost = false;
            this.isReviews = false;
            this.isDetails = true;
        },

        async geInterpreterDetails() {
            const id = this.$route.params.id;
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/language/interpreters/${id}`,
                    method: "GET",
                })
                this.interpreter = resp.data.data;
                this.interpreter = Object.assign({}, resp.data.data);
                this.interpreter.specializations.map((inp) => {
                    inp.title = inp.title === 's-lang' ? 'Sign Language' : inp.title
                })
            } catch (error) {
                console.log(error)
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async rateInterpreter(interpreter) {
            this.btnRating = "Rating..."
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/language/interpreter/ratings`,
                    data: {
                        interpreter_id: interpreter.interpreter_id,
                        rating: this.rating,
                        comment: this.comment
                    },
                    method: "POST",
                })
                this.btnRating = "Rate Now"
                this.$root.$refs.A.makeToast('success', resp.data.message)
            } catch (error) {
                this.btnRating = "Rate Now"
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async rateHost(interpreter) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/language/interpreter/ratings`,
                    data: {
                        event_id: interpreter.interpreter_id,
                        rating: interpreter.average_ratings,
                        comment: this.comment
                    },
                    method: "POST",
                })
                this.$bvModal.hide('rate-host')
                this.$root.$refs.A.makeToast('success', resp.data.message)

            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }

        },
        async proposeDateTime() {
            const data = {
                guest_address: this.guest_address,
                guest_id: this.currentUser.user_id,
                proposed_start: this.dateRange.startDate,
                proposed_end: this.dateRange.endDate,
                interpreter_id: this.interpreter.interpreter_id
            }
            this.modalbtnText = "Sending..."
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/language/interpreter/check-availability`,
                    data: data,
                    method: "POST",
                })
                this.loading = false
                this.modalbtnText = "Propose Time"
                this.$root.$refs.A.makeToast('success', resp.data.message)
                this.$bvModal.hide('availability')
            } catch (error) {
                this.modalbtnText = "Propose Time"
                this.loading = false
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }

        }

    }

}
</script>

<style scoped>
.row {
    margin-left: 0 !important;
}

p.breadcrums a {
    color: #565C63 !important
}

._container {
    padding: 10px 10px 20px;
}

.img-bg {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.profile-contain img {
    border-radius: 50%;
    height: 110px;
    width: 110px
}

.bordered {
    border-left: 2px solid #ccc;
}

.card-no-shadow {
    border: 1px solid #ccc
}

.time-frame {
    background: rgba(247, 177, 49, 0.15);
    border-radius: 16px;
    padding: 2px 13px;
    text-transform: uppercase;
    margin-top: 10px
}

.inst-details {
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.15);
    border-radius: 16px 16px 0px 0px;
    padding: 10px;
}

.btn-grey {
    background: #565C63 !important;
    border-radius: 4px !important;
    color: #fff !important
}

.light-input-container {
    border: 1px solid rgba(86, 92, 99, 0.54);
    padding: 10px;
    border-radius: 5px;
    background: #fff;
}

.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 8px;
    padding: 20px 16px;
    border: none;
    height: 59px;
}

.custom-input-group {
    box-shadow: none !important;
    margin: 0 !important
}

.custom-input-group .input-group-prepend {
    padding-top: 18px !important;
}

.btn-culture {
    padding: 10px 60px !important;
}

.form-control {
    height: calc(2em + 0.75rem + 15px) !important;

}

.input-group {
    margin: 0
}

.form-control:focus {
    outline: none !important;
    box-shadow: none !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select .caret {
    padding-right: 10px;
}

.custom-control {
    height: calc(1.5em + 0.75rem + 15px) !important;

}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    background-color: #F6F7F7;
}

.inner-header-box {
    border-radius: 16px;
    cursor: pointer;
}

.inner-header-box:hover>div {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box.active {
    background: #fff;
    color: #fff;
}

.inner-header-box>div {
    margin: 10px;
    background: #fff;
    padding: 15px;
    border-radius: 4px;
}

.inner-header-box.active>div {
    margin: 10px;
    background: #000;
    padding: 15px;
    border-radius: 4px;
}

.inner-header-box:hover .b-icon.bi,
.inner-header-box.active .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.font18bold {
    font-size: 18px;
    font-weight: 500;
}

.font24bold {
    font-size: 24px;
    font-weight: 500;
}

.custom-notify {
    border-radius: 8px;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-in-out !important;
}

.country-list-span {
    background: #000;
    color: #fff;
    padding: 15px 30px;
    border-radius: 8px;
    margin-right: 25px;
}

.bx-sh {
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
}

.autocomplete-list {
    top: 62px !important;
    text-align: left !important;
    width: 100% !important
}

.autocomplete-list ul li {
    border: none !important;
    transition: all 0.1s ease-in-out !important;
}

.autocomplete-list ul li:hover {
    background: #F6F7F7;
}

.country-list-span span:nth-child(2) {
    cursor: pointer
}

.autocomplete-list img,
.country-list-span img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}

.rating-title {
    font-size: 32px;
    font-weight: bold
}

.rating-profile {
    border-radius: 50%;
    height: 50px;
    width: 50px
}
</style>
